import { all, takeLatest } from 'redux-saga/effects';

import { projectImportFileAction } from '@/redux/actions/project-import';

import { projectImportFileSaga } from './project-import';

export default function* root(): Generator {
  yield all([takeLatest(projectImportFileAction.request.type, projectImportFileSaga)]);
}
